import { useEffect, useRef } from "react";

/**
 * Call `onEscape` when the Escape key is pressed while `active` is true.
 * Used by modal dialogs so they can be dismissed from the keyboard.
 */
export default function useEscapeKey(active, onEscape) {
  const handlerRef = useRef(onEscape);
  handlerRef.current = onEscape;

  useEffect(() => {
    if (!active) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape" || e.key === "Esc") {
        handlerRef.current?.(e);
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [active]);
}

export { useEscapeKey };
